import {
    FETCH_CHECKER_LIST_SUCCESS,
    FETCH_CHECKER_LIST_REQUEST,
    FETCH_CHECKER_LIST_ERROR,
    SHOW_CHECKER_LOADER,
    HIDE_CHECKER_LOADER,
    GET_ACTIVE_CHECKER_REPORT_REQUEST,
    GET_ACTIVE_CHECKER_REPORT_SUCCESS,
    GET_ACTIVE_CHECKER_REPORT_ERROR,
    GENERATE_CHECKER_REPORT_REQUEST,
    GENERATE_CHECKER_REPORT_SUCCESS,
    GENERATE_CHECKER_REPORT_ERROR,
    DOWNLOAD_CHECKER_REPORT_ERROR,
    DOWNLOAD_CHECKER_REPORT_REQUEST,
    DOWNLOAD_CHECKER_REPORT_SUCCESS,
    GET_STATIC_DATA_REQUEST_CHECKER,
    GET_STATIC_DATA_ERROR_CHECKER,
    GET_STATIC_DATA_SUCCESS_CHECKER,
} from './checker.constants';

export const fetchCheckerRequest = payload => ({
    type: FETCH_CHECKER_LIST_REQUEST,
    payload,
});

export const fetchCheckerSuccess = payload => ({
    type: FETCH_CHECKER_LIST_SUCCESS,
    payload,
});

export const fetchCheckerError = payload => ({
    type: FETCH_CHECKER_LIST_ERROR,
    payload,
});

export const generateCheckerReportRequest = payload => ({
    type: GENERATE_CHECKER_REPORT_REQUEST,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_CHECKER_REPORT_SUCCESS,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_CHECKER_REPORT_ERROR,
    payload,
});

export const downloadCheckerReportRequest = payload => ({
    type: DOWNLOAD_CHECKER_REPORT_REQUEST,
    payload,
});

export const downloadCheckerReportSuccess = payload => ({
    type: DOWNLOAD_CHECKER_REPORT_SUCCESS,
    payload,
});

export const downloadCheckerReportError = payload => ({
    type: DOWNLOAD_CHECKER_REPORT_ERROR,
    payload,
});

export const getActiveCheckerReportRequest = payload => ({
    type: GET_ACTIVE_CHECKER_REPORT_REQUEST,
    hideLoader: payload.hideLoader,
    payload,
});

export const getActiveCheckerReportSuccess = payload => ({
    type: GET_ACTIVE_CHECKER_REPORT_SUCCESS,
    payload,
});

export const getActiveCheckerReportError = payload => ({
    type: GET_ACTIVE_CHECKER_REPORT_ERROR,
    payload,
});

export const getStaticDataRequestChecker = payload => ({
    type: GET_STATIC_DATA_REQUEST_CHECKER,
    payload,
});

export const getStaticDataSuccessChecker = payload => ({
    type: GET_STATIC_DATA_SUCCESS_CHECKER,
    payload,
});

export const getStaticDataErrorChecker = payload => ({
    type: GET_STATIC_DATA_ERROR_CHECKER,
    payload,
});

export const showLoader = () => ({ type: SHOW_CHECKER_LOADER });

export const hideLoader = () => ({ type: HIDE_CHECKER_LOADER });
